import { create } from 'zustand'
import type { PlantGardenV2Snapshot } from '@/entities/plant-garden-v2'

interface PlantGardenV2ProjectionState {
  snapshot: PlantGardenV2Snapshot | null
  studentId: string | null
}

/** UI projection only. PlantGardenV2Runtime is the only publisher. */
export const usePlantGardenV2Store = create<PlantGardenV2ProjectionState>(() => ({
  snapshot: null,
  studentId: null,
}))
